import { AppUsageStatisticModel } from "client/Api/Analytics/analyticsStatistics";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { getReactColorAttributes } from "client_legacy/ndaw/appColor";
import { isNil } from "client/Misc/utils";
import classNames from "classnames";
import { AppIcon, Icon } from "client/Components";
import styles from "./AnalyticsAppList.module.less";
import { AnalyticsDetailedList } from "./AnalyticsDetailedList";

export type AnalyticsAppListProps = {
	items: readonly AppUsageStatisticModel[];
};

export const AnalyticsAppList = (props: AnalyticsAppListProps): ReactElement => {
	const {
		items
	} = props;

	return (
		<AnalyticsDetailedList>
			{items.map((x: AppUsageStatisticModel, i: number) => (
				<AppItem
					key={i}
					appUsage={x}
				/>
			))}
		</AnalyticsDetailedList>
	);
};
AnalyticsAppList.displayName = "AnalyticsAppList";

type AppItemProps = {
	appUsage: AppUsageStatisticModel;
};

const AppItem = (props: AppItemProps): ReactElement => {
	const {
		appUsage
	} = props;

	const {
		colorClass,
		colorStyle
	} = getReactColorAttributes(appUsage.appColorViewModel);

	const isDeletedApp: boolean = isNil(appUsage.appId);

	return (
		<AnalyticsDetailedList.Item
			thumbnail={(
				<div
					style={colorStyle}
					className={classNames(
						colorClass,
						styles.appIconWrapper,
						{
							[styles.appIconWrapper_deletedApp]: isDeletedApp
						}
					)}
				>
					{isDeletedApp || isNil(appUsage.appImageDisplayInfo)
						? (
							<Icon value="grid-2" />
						)
						: (
							<div className={styles.appIcon}>
								<AppIcon
									value={appUsage.appImageDisplayInfo}
									color="inherit"
								/>
							</div>
						)}
				</div>
			)}
			title={isDeletedApp ? localize("_DeletedApp") : appUsage.appName}
			counter={appUsage.userCount}
			isDisabled={isDeletedApp}
		/>
	);
};
AppItem.displayName="AppItem";